module.exports = __webpack_public_path__ + "a2af22aec15c9e7236da6d94ff0d9beb.svg";